import { OptionType } from "@portal/BaseComponents/CheckBox/type";
import {
  CustomFieldDataResponse,
  CustomFieldOperatorOptions,
  CustomFieldOperatorType,
  NonNumericCustomField,
  NumericCustomFiled,
} from "@portal/types/entities/custom-field";
import { CustomFieldRangeValueType } from "./Numeric/NumericCustomField";
import { DateRangeString } from "../DateRange/type";
import { DateSelectedValue } from "./CustomFieldDateFilter";

export function getCustomFieldNonNumberOptions(
  customField: CustomFieldDataResponse["options"]
): OptionType[] {
  return customField.map((field) => {
    return { label: field, value: field };
  });
}

export const customFieldOptions: CustomFieldOperatorOptions[] = [
  {
    label: "Greater than or equals",
    value: "GOE",
  },
  {
    label: "Less than or equals",
    value: "LOE",
  },
  {
    label: "Equals",
    value: "IN",
  },
  {
    label: "Between",
    value: "BTWN",
  },
];

export const nonNumericCustomField: Array<NonNumericCustomField> = [
  "BOOLEAN",
  "DATE",
  "DATETIME",
  "TEXT",
  "SINGLE_SELECT",
];

export const numericCustomField: Array<NumericCustomFiled> = [
  "DECIMAL",
  "NUMBER",
];

export function getNumberBasedText(
  value?: CustomFieldRangeValueType<CustomFieldOperatorType>
) {
  switch (value?.type) {
    case "IN":
      return `Equals ${value.value}`;
    case "GOE":
      return `Greater than or equals ${value.value}`;
    case "LOE":
      return `Less than or equals ${value.value}`;
    case "BTWN":
      return `${
        (value.value as CustomFieldRangeValueType<"BTWN">["value"]).from
      } to ${(value.value as CustomFieldRangeValueType<"BTWN">["value"]).to} `;

    default:
      return "Choose Value";
  }
}

export function getDateRangeFromSelectedValue(
  selectedValue?: DateSelectedValue
): DateRangeString {
  if (!selectedValue) {
    return { from: "", to: "", type: undefined };
  }

  if (selectedValue.date_range) {
    return {
      from: selectedValue.value.from?.toString(),
      to: selectedValue.value.to?.toString(),
      type: selectedValue.date_range,
    };
  } else {
    return {
      from: selectedValue.value.from?.toString(),
      to: selectedValue.value.to?.toString(),
      type: selectedValue.date_range,
    };
  }
}
